import { getVisitorId, getCookie } from './cookieUtils';
import {
  ITAG_ARR, OMN_OBJ_ARR, OMN_ARR, RET_KEYS, EU_MARKET_LIST,
} from './constants';
import {
  getSaveAndRetrieveParams, isPresent, getDigitalData, retrieveItagData, retrieveOmnObjData,
  retrieveOmnData, decodeVeidStr, getOrientation, getDate, getRandomGuid,
} from './commonUtils';
import { makeRequest } from './makeRequest';

export const campaignInternationalData = {
  envUrl: process.env.GLOBAL_CAMPAIGN_FAAS_URL,
  gctDataArr: ['', '', '', '', '', '', '', '', ''],
  isGCTSupportedEvent: false,
  gctParams: '',
  eucLocale: '',
  isEUCookieConsentGiven: false,
  euConsentVal: '',
  gctVidVal: '',
};

export const initialize = () => {
  if (window.document.cookie.indexOf('gctrac') < 0) {
    return getDate() + getRandomGuid();
  }
  return getVisitorId();
};

/* eslint-disable complexity */
export const retrieveMarketAndProduct = (gctDataArr) => {
  const localGctDataArr = gctDataArr;
  if (isPresent(localGctDataArr[0]) && localGctDataArr[0].length >= 2) {
    localGctDataArr[0] = localGctDataArr[0].substring(0, 2);
  } else if (isPresent(window.Bootstrapper) && isPresent(window.Bootstrapper.ensMarket)) {
    let mktVar = window.Bootstrapper.ensMarket;
    if (isPresent(mktVar) && mktVar.indexOf('_') >= 0) {
      mktVar = mktVar.substr(0, mktVar.indexOf('_'));
      localGctDataArr[0] = mktVar;
    }
  }
  if (isPresent(localGctDataArr[0]) && localGctDataArr[0].toLowerCase() === 'gb') localGctDataArr[0] = 'UK';
  /* istanbul ignore else */
  if (!isPresent(localGctDataArr[3]) || (isPresent(localGctDataArr[3])
    && localGctDataArr[3].length > 0)) {
    if (isPresent(window.omn_mrprodview)) localGctDataArr[3] = window.omn_mrprodview;
    else if (isPresent(window.omn) && isPresent(window.omn.mrprodview)) {
      localGctDataArr[3] = window.omn.mrprodview;
    } else if (isPresent(window.itag_mrprodview)) localGctDataArr[3] = window.itag_mrprodview;
  }
  return localGctDataArr;
};

/* eslint-disable complexity */
export const sendData = (gctVidVal, gctDataArr) => {
  const intlUrl = `${campaignInternationalData.envUrl}captureIntl.do`;
  let params = String('');
  params = params.concat('&oneAmex=', 'AXPSupplierScriptNOA');
  if (gctVidVal != null && isPresent(gctVidVal)) params = params.concat('&gctvid=', gctVidVal);
  if (isPresent(gctDataArr[0])) params = params.concat('&noAX_market=', gctDataArr[0]);
  if (isPresent(gctDataArr[1])) params = params.concat('&nonAX_pcn=', gctDataArr[1]);
  if (isPresent(gctDataArr[2])) params = params.concat('&nonAX_eep=', gctDataArr[2]);
  if (isPresent(gctDataArr[3])) params = params.concat('&nonAX_prodCode=', gctDataArr[3]);
  if (isPresent(gctDataArr[4])) params = params.concat('&nonAX_zipCode=', gctDataArr[4]);
  if (isPresent(gctDataArr[5])) params = params.concat('&nonAX_applyflow=', gctDataArr[5]);
  if (isPresent(gctDataArr[6])) params = params.concat('&nonAX_cardtype=', gctDataArr[6]);
  if (isPresent(gctDataArr[7])) params = params.concat('&nonAX_rsvp=', gctDataArr[7]);
  if (isPresent(gctDataArr[8])) {
    params = params.concat('&nonAX_events=', gctDataArr[8]);
    if (gctDataArr[8] === 'event1' || gctDataArr[8] === 'event47') {
      params = params.concat(':');
      if (typeof (gctVidVal) !== 'undefined' && gctVidVal !== null && gctVidVal !== '') {
        getSaveAndRetrieveParams(RET_KEYS).forEach((value, key) => {
          /* istanbul ignore else */
          if (isPresent(value)) {
            params = params.concat('&', key, '=', value);
          }
        });
      }
    }
  }
  params = params.concat('&nonAX_rwd_exp=', `${document.body.clientWidth}px|${getOrientation()}`);
  params = params.concat('&fullURL=', encodeURIComponent(decodeVeidStr(document.URL)));
  params = params.concat('&refURL=', encodeURIComponent(decodeVeidStr(document.referrer)));
  if (typeof (window.s) !== 'undefined' && isPresent(window.s.account)) params = params.concat('&rsid=', window.s.account);
  if (campaignInternationalData.isEUCookieConsentGiven) {
    params = params.concat('&isEUConsentGiven=', `${campaignInternationalData.isEUCookieConsentGiven}`);
    params = params.concat('&euConsentVal=', `${campaignInternationalData.euConsentVal}`);
    // campaignInternationalData.isEUCookieConsentGiven = false;
  }
  const digitalData = getDigitalData(false);
  if (typeof digitalData !== 'undefined') {
    params = params.concat('&nonAX_digitalDataJSON=', encodeURIComponent(JSON.stringify(digitalData)));
  }
  console.log('params are :', params);
  makeRequest(intlUrl, params);
  return true;
};

export const retrieveAndSetPageData = () => {
  campaignInternationalData.gctDataArr = retrieveItagData(ITAG_ARR,
    campaignInternationalData.gctDataArr);
  campaignInternationalData.gctDataArr = retrieveOmnObjData('transactionID', OMN_OBJ_ARR,
    campaignInternationalData.gctDataArr);
  campaignInternationalData.gctDataArr = retrieveOmnData('omn_transactionID', OMN_ARR,
    campaignInternationalData.gctDataArr);
  campaignInternationalData.gctDataArr = retrieveMarketAndProduct(
    campaignInternationalData.gctDataArr);
  return true;
};

export const triggerGCTEUCall = (euResponse) => {
  if (euResponse === 'true' || (typeof euResponse === 'string' && euResponse.indexOf('A:Y') >= 0)) {
    campaignInternationalData.isEUCookieConsentGiven = true;
    campaignInternationalData.euConsentVal = euResponse;
    // icats_obj.verifyGCTDO();
    //  processInternationalEvents();
    sendData(campaignInternationalData.gctVidVal, campaignInternationalData.gctDataArr);
  } else console.log(`Received response is :${euResponse}`);
};

export const isEUCkConsentSet = () => {
  let gctEUCkConsentVal = getCookie('CookieConsent');
  let returnVal = false;
  if (isPresent(gctEUCkConsentVal)
    && gctEUCkConsentVal.indexOf(campaignInternationalData.eucLocale) >= 0) {
    gctEUCkConsentVal = gctEUCkConsentVal.substring(
      gctEUCkConsentVal.indexOf(campaignInternationalData.eucLocale),
      gctEUCkConsentVal.indexOf(campaignInternationalData.eucLocale) + 21);
    if (gctEUCkConsentVal.indexOf('A:Y') >= 0) returnVal = true;
  } else {
    if (typeof (window.EuCookieConsentHandlers) !== 'undefined') {
      if (window.EuCookieConsentHandlers.indexOf(triggerGCTEUCall) < 0) {
        window.EuCookieConsentHandlers.push(triggerGCTEUCall);
      }
    } else window.EuCookieConsentHandlers = [triggerGCTEUCall];
    returnVal = false;
  }
  return returnVal;
};

export const isEULocaleSet = () => {
  let splitLocale = '';
  let euMkt = '';
  // eslint-disable-next-line no-undef
  if (typeof (window.euLocale) !== 'undefined' && window.euLocale) {
    // eslint-disable-next-line no-undef
    campaignInternationalData.eucLocale = window.euLocale;
    // eslint-disable-next-line no-undef
  } else if (typeof window.NAV !== 'undefined' && typeof window.NAV.EUCheck !== 'undefined'
    // eslint-disable-next-line no-undef
    && window.NAV.EUCheck.locale) {
    // eslint-disable-next-line no-undef
    campaignInternationalData.eucLocale = window.NAV.EUCheck.locale;
  } else if (window.document.documentElement && window.document.documentElement.lang) {
    campaignInternationalData.alternateLocale = window.document.documentElement.lang;
  }
  if ((typeof campaignInternationalData.eucLocale === 'undefined'
    || (typeof campaignInternationalData.eucLocale !== 'undefined'
      && campaignInternationalData.eucLocale.indexOf('_') < 0))
    && (typeof campaignInternationalData.alternateLocale !== 'undefined'
      && campaignInternationalData.alternateLocale.indexOf('-') > -1)) {
    splitLocale = campaignInternationalData.alternateLocale.split('-');
    /* if (typeof splitLocale !== 'undefined' && splitLocale.length > 1) { */
    campaignInternationalData.eucLocale = `${splitLocale[1]}_${splitLocale[0]}`;
    // eslint-disable-next-line prefer-destructuring
    euMkt = splitLocale[1];
    // }
  } else if (typeof campaignInternationalData.eucLocale !== 'undefined'
    && campaignInternationalData.eucLocale.indexOf('_') > -1) {
    splitLocale = campaignInternationalData.eucLocale.split('_');
    // eslint-disable-next-line prefer-destructuring
    /* if (typeof splitLocale !== 'undefined' && splitLocale.length > 0) */
    // eslint-disable-next-line prefer-destructuring
    euMkt = splitLocale[0];
  }
  if (typeof (campaignInternationalData.eucLocale) !== 'undefined'
    && typeof (splitLocale) !== 'undefined'
    && Array.isArray(splitLocale) && splitLocale.length > 0
    && EU_MARKET_LIST.indexOf(euMkt) >= 0) {
    isEUCkConsentSet();
    return true;
  }
  return false;
};

export const processInternationalEvents = () => {
  const gctVidVal = initialize();
  retrieveAndSetPageData();
  sendData(gctVidVal, campaignInternationalData.gctDataArr);
  campaignInternationalData.gctVidVal = gctVidVal;
  isEULocaleSet();
  return '{"status":"success"}';
};
